export const isLite = process.env.REACT_APP_IS_LITE === 'true' || document.referrer.toLowerCase().includes("navpro");
